
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function authenticateUser1(name,email,password){
    let emailCheck = /^[a-zA-Z0-9+_.-]+@(gmail|yahoo|outlook)\.com$/;
    let passwordCheck = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

    if(!emailCheck.test(email)){
        toast.error('Enter a valid email', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            });
        return false;
    }
    if(!passwordCheck.test(password)){
        toast.error('Your password must contain Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            });
        return false;
    }

    return true;
}

 function FormSubmit(e){
    e.preventDefault();
    // const Navigate = useNavigate();
    const data = new FormData(e.target);
    const nameValue = data.get('nameInput');
    const mailValue = data.get('mailInput');
    const passwordValue = data.get('passwordInput');
    console.log(nameValue,mailValue,passwordValue);

    if(authenticateUser1(nameValue,mailValue,passwordValue)){
        const obj = {
            name : nameValue,
            mail : mailValue,
            password : passwordValue
        }
        localStorage.setItem('user',JSON.stringify(obj));
        localStorage.setItem('islogin','yes');
        toast.success("You have successfully login", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            });
        window.location = '/';
        // Navigate('/');
    }
    
}
export default FormSubmit;